// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._W23SI{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}._W23SI:hover{opacity:.7}.ok3JVb{visibility:hidden !important;width:0 !important;min-width:0 !important;height:0 !important;min-height:0 !important;margin:0 !important;padding:0 !important;opacity:0 !important}.jWn2rp{position:absolute;z-index:10000;top:10px;left:10px;overflow:scroll;width:400px;height:250px;border-radius:3px;background-color:rgba(0,0,0,0.95)}.jWn2rp .fCVbVB{position:absolute;top:10px;right:5px;cursor:pointer;color:white}.jWn2rp .fCVbVB:hover{opacity:.8}.jWn2rp .r3wsDv{font-size:8px;line-height:8px;margin:5px;padding:5px;color:white}.jWn2rp .r3wsDv .w5ubjk{color:green}.jWn2rp .r3wsDv .W8s9eH{color:darkorange}.jWn2rp .r3wsDv .f9Zt7q{color:blue}.jWn2rp .r3wsDv .ywOnje{color:magenta}.jWn2rp .r3wsDv .qziuPz{color:white}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controlButton": "_W23SI",
	"hidden": "ok3JVb",
	"debugPanel": "jWn2rp",
	"closeButton": "fCVbVB",
	"infoContainer": "r3wsDv",
	"string": "w5ubjk",
	"number": "W8s9eH",
	"boolean": "f9Zt7q",
	"null": "ywOnje",
	"key": "qziuPz"
};
export default ___CSS_LOADER_EXPORT___;
